export default __webpack_public_path__ + "static/media/Step-9.8d30f53a.webm";